import React from "react";
import "./UserManagement.css";
import FileExport from "./../../Assets/Images/CommanImages/fileexport.png";
import Filter from "./../../Assets/Images/CommanImages/filter.png";
import columnaddition from "./../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "./../../Assets/Images/CommanImages/updown.png";
import searchicon from "./../../Assets/Images/CommanImages/searchyellow.png";
const UserManagement = () => {
  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        className=""
        style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
      >
        <div className="Header-up ">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>User Management</p>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter users. Export a list of users or search for a
          user. When searching, enter at least two characters in the search
          field.
        </p>

        <div
          style={{ display: "flex", alignItems: "center", marginTop: "1.5%" }}
        >
          <input
            type="text"
            placeholder="Search.."
            name="search"
            className="input-top-UM-uni"
          />

          <img src={searchicon} className="search-icon-URM" alt="addition" />
        </div>
        <div style={{ textAlign: "end", paddingRight: "10px" }}>
          Displaying 1 - 50 of 66 records |{" "}
          <a style={{ color: "#337AB7" }} href="">
            10
          </a>{" "}
          <a style={{ color: "#337AB7" }} href="">
            50
          </a>{" "}
          <a style={{ color: "#337AB7" }} href="">
            100
          </a>{" "}
          <a style={{ color: "#337AB7" }} href="">
            500
          </a>
        </div>

        <div
          className="row-cs-uni"
          style={{
            backgroundColor: "#D6D6D6",
            marginTop: "1%",
            borderTop: "1px solid grey",
            borderBottom: "1px solid grey",
          }}
        >
          <div
            className="col-cs2 UM-header-margins"
            style={{
              backgroundColor: "#FFBD20",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={Filter}
              style={{ height: "25px", width: "25px" }}
              alt="addition"
            />
            <span style={{ marginLeft: "10px" }}>Advance Filter</span>
          </div>
          <div
            className="col-cs UM-header-margins"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={FileExport}
              style={{ height: "25px", width: "25px" }}
              alt="addition"
            />
            <span style={{ marginLeft: "10px" }}>Export</span>
          </div>
          <div
            className="col-cs1_5 UM-header-margins"
            style={{
              textAlign: "end",
              marginRight: "8px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={columnaddition}
              style={{ height: "25px", width: "25px" }}
              alt="addition"
            />
            <span style={{ marginLeft: "10px" }}>Column Selection</span>
          </div>
        </div>
        <table className="table_UM-uni" style={{ width: "100%" }}>
          <tr>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                First Name
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Last Name
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Manager Name{" "}
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Employee ID{" "}
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Email ID{" "}
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Department{" "}
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Last Login Date{" "}
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Status{" "}
                <img
                  src={updown}
                  style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                  alt="addition"
                />
              </span>
            </th>
            <th style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
              
              </span>
            </th>
          </tr>
          <tr>
            <td className="table-light-grey-scale">
              <a href="" className="hyperlink-UM-uni ">
                Viraj{" "}
              </a>
            </td>
            <td className="color6A6A6A table-light-grey-scale">Shrivastava</td>
            <td className="color6A6A6A table-light-grey-scale">
              {" "}
              Himansu Pandey
            </td>
            <td className="color6A6A6A table-light-grey-scale"> 4524845P</td>
            <td className="color6A6A6A table-light-grey-scale">
              virajshrivastava2001@gmail.com
            </td>
            <td className="color6A6A6A table-light-grey-scale"> IT</td>
            <td className="color6A6A6A table-light-grey-scale"> 20 May 2024</td>
            <td className="color6A6A6A table-light-grey-scale"> Active</td>
            <td className="color6A6A6A table-light-grey-scale"></td>
          </tr>
          <tr>
            <td className="table-grey-scale">
              <a href="" className="hyperlink-UM-uni ">
                Viraj{" "}
              </a>
            </td>
            <td className="color6A6A6A table-grey-scale">Shrivastava</td>
            <td className="color6A6A6A table-grey-scale"> Himansu Pandey</td>
            <td className="color6A6A6A table-grey-scale"> 4524845P</td>
            <td className="color6A6A6A table-grey-scale">
              virajshrivastava2001@gmail.com
            </td>
            <td className="color6A6A6A table-grey-scale"> IT</td>
            <td className="color6A6A6A table-grey-scale"> 20 May 2024</td>
            <td className="color6A6A6A table-grey-scale">Active</td>
            <td className="color6A6A6A table-grey-scale"></td>
          </tr>
          <tr>
            <td className="table-light-grey-scale">
              <a href="" className="hyperlink-UM-uni">
                Viraj{" "}
              </a>
            </td>
            <td className="color6A6A6A table-light-grey-scale">Shrivastava</td>
            <td className="color6A6A6A table-light-grey-scale table-light-grey-scale">
              {" "}
              Himansu Pandey
            </td>
            <td className="color6A6A6A table-light-grey-scale"> 4524845P</td>
            <td className="color6A6A6A table-light-grey-scale">
              {" "}
              virajshrivastava2001@gmail.com
            </td>
            <td className="color6A6A6A table-light-grey-scale">IT</td>
            <td className="color6A6A6A table-light-grey-scale">20 May 2024</td>
            <td className="color6A6A6A table-light-grey-scale"> Active</td>
            <td className="color6A6A6A table-light-grey-scale"></td>
          </tr>
        
          <tr>
            <td className="table-grey-scale">
              <a href="" className="hyperlink-UM-uni ">
                Viraj{" "}
              </a>
            </td>
            <td className="color6A6A6A table-grey-scale">Shrivastava</td>
            <td className="color6A6A6A table-grey-scale"> Himansu Pandey</td>
            <td className="color6A6A6A table-grey-scale"> 4524845P</td>
            <td className="color6A6A6A table-grey-scale">
              virajshrivastava2001@gmail.com
            </td>
            <td className="color6A6A6A table-grey-scale"> IT</td>
            <td className="color6A6A6A table-grey-scale"> 20 May 2024</td>
            <td className="color6A6A6A table-grey-scale">Active</td>
            <td className="color6A6A6A table-grey-scale"></td>
          </tr>
          <tr>
            <td className="table-light-grey-scale">
              <a href="" className="hyperlink-UM-uni">
                Viraj{" "}
              </a>
            </td>
            <td className="color6A6A6A table-light-grey-scale">Shrivastava</td>
            <td className="color6A6A6A table-light-grey-scale table-light-grey-scale">
              {" "}
              Himansu Pandey
            </td>
            <td className="color6A6A6A table-light-grey-scale"> 4524845P</td>
            <td className="color6A6A6A table-light-grey-scale">
              {" "}
              virajshrivastava2001@gmail.com
            </td>
            <td className="color6A6A6A table-light-grey-scale">IT</td>
            <td className="color6A6A6A table-light-grey-scale">20 May 2024</td>
            <td className="color6A6A6A table-light-grey-scale"> Active</td>
            <td className="color6A6A6A table-light-grey-scale"></td>
          </tr>
        
        </table>
      </div>
    </div>
  );
};

export default UserManagement;
